import { InjectionToken } from '@angular/core';
import { Constants } from 'src/models/contants.models';

export let APP_CONFIG = new InjectionToken<AppConfig>('app.config');

export interface AppConfig {
  availableLanguages: Array<{ code: string; name: string }>;
  defaultThemeMode: string;
  demoMode: boolean;
}

export const BaseAppConfig: AppConfig = {
  availableLanguages: [
    {
      code: 'nl',
      name: 'Dutch',
    },
    {
      code: 'en',
      name: 'English',
    },
    {
      code: 'de',
      name: 'Deutsch',
    },
    {
      code: 'fr',
      name: 'Français',
    },
  ],
  defaultThemeMode: Constants.THEME_MODE_LIGHT,
  demoMode: true,
};
